import {
  words,
  stateKeysToSetAddress,
  // stateKeysToSetUserName,
} from './globalState';
import {
  getAddressFromKeyNW,
  getValidKeyPairs,
  signWithKeyNW,
} from './keysAndSigning';
// import { loadDeck } from './monadomCore';
import {
  getBalancesMonaparty,
  getAssetInfo,
} from './blockchain';
import {
  getUser,
  setAddressesInCookie,
} from './monacottoMisc';
import {
  syncHttpRequest2,
  devLog,
} from './utils';

// 利用登録の必須項目（ユーザー名、利用規約・プライバシーポリシーの同意）を確かめる。欠けていれば通知して false
function checkRequiredItemsForSetup({ dispatch, configure, language }) {
  if (configure.userName === undefined || configure.userName === null || configure.userName === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.userNameMustBeFilled[language] });
    return false;
  }

  if (configure.acceptedVersionOfTheTermsAndConditions === undefined ||
      configure.acceptedVersionOfTheTermsAndConditions === null ||
      configure.acceptedVersionOfTheTermsAndConditions === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.acceptTheTermsAndConditions[language] });
    return false;
  }

  if (configure.acceptedVersionOfPrivacyPolicy === undefined ||
      configure.acceptedVersionOfPrivacyPolicy === null ||
      configure.acceptedVersionOfPrivacyPolicy === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.acceptThePrivacyPolicy[language] });
    return false;
  }

  return true;
}

// 「設定」ボタン押下 HANDLE CLICK SETUP
async function handleClickSetup({
  dispatch,
  cookies,
  setCookie,
  keyPairs,
  keyPairsInPoolAll,
  session,
  assetInfos,
  configure,
  walletType,
  network,
  clientParameters,
  marginOfSessionTime,
  language,
  active = {},
}) {
  let addressMainActual;
  let message;
  let signature;
  let request = {};
  let messages = {};
  let result;
  let keyPair;

  // state固定
  const stateFixed = {
    addressMain: configure.addressMain,
    userName: configure.userName,
    addressCardFromDefault: configure.addressCardFromDefault ?? '',
    addressPayProceedsToDefault: configure.addressPayProceedsToDefault ?? '',
    addressPayFromDefault: configure.addressPayFromDefault ?? '',
    addressSendCardToDefault: configure.addressSendCardToDefault ?? '',
    homed: configure.homed ?? false,
    profileText: configure.profileText ?? '',
    imageMain: configure.imagesNew?.main,
    acceptedVersionOfTheTermsAndConditions: configure.acceptedVersionOfTheTermsAndConditions ?? null,
    acceptedVersionOfPrivacyPolicy: configure.acceptedVersionOfPrivacyPolicy ?? null,
    signatureVersion: clientParameters.signatureVersion.configure,
    walletType,
    addressCheck: 'off',
  };

  // // 必須項目チェック

  if (!checkRequiredItemsForSetup({ dispatch, configure, language })) {
    return;
  }

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: keyPairsInPoolAll });

  const clientTime = Date.now();

  if (keyPairs !== undefined && keyPairs !== null) {
    keyPair = keyPairs[0];

    try {
      addressMainActual = getAddressFromKeyNW({ dispatch, keyPair, language, network });
    }
    catch (err) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[language] });
      return 'rejected';
    }

    stateFixed.addressMain = addressMainActual;

    message = `I want to use monacotto. My main address is ${stateFixed.addressMain}. My name is ${stateFixed.userName}. I will send cards from ${stateFixed.addressCardFromDefault} and I want to receive proceeds in ${stateFixed.addressPayProceedsToDefault} as default. I will pay from ${stateFixed.addressPayFromDefault} and I want to receive cards in ${stateFixed.addressSendCardToDefault} as default. I accept the terms and conditions version ${stateFixed.acceptedVersionOfTheTermsAndConditions} and privacy policy version ${stateFixed.acceptedVersionOfPrivacyPolicy}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
    devLog('message', message);

    try {
      signature = signWithKeyNW({ dispatch, keyPair, message, network, language });
    }
    catch (error) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[language] });
      return 'rejected';
    }
  }
  else if (
    stateFixed.walletType === 'keypool' &&
    stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined
  ) {
    addressMainActual = stateFixed.addressMain;

    message = `I want to use monacotto. My main address is ${stateFixed.addressMain}. My name is ${stateFixed.userName}. I will send cards from ${stateFixed.addressCardFromDefault} and I want to receive proceeds in ${stateFixed.addressPayProceedsToDefault} as default. I will pay from ${stateFixed.addressPayFromDefault} and I want to receive cards in ${stateFixed.addressSendCardToDefault} as default. I accept the terms and conditions version ${stateFixed.acceptedVersionOfTheTermsAndConditions} and privacy policy version ${stateFixed.acceptedVersionOfPrivacyPolicy}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
    devLog('message', message);

    try {
      signature = signWithKeyNW({ dispatch, keyPair: keyPairsInPool[stateFixed.addressMain].keyPair, message, network, language });
    }
    catch (error) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[language] });
      return 'rejected';
    }
  }
  else if (
    stateFixed.walletType === 'keypool' &&
    active.addressMain !== undefined && active.addressMain !== null && active.addressMain !== '' &&
    keyPairsInPool[active.addressMain]?.keyPair !== undefined
  ) {
    const keyPair = keyPairsInPool[active.addressMain].keyPair;

    try {
      addressMainActual = getAddressFromKeyNW({ dispatch, keyPair, language, network });
    }
    catch (err) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[language] });
      return 'rejected';
    }

    // addressMainが指定されていなければ、addressMainActualをaddressMainとして扱う。
    if (stateFixed.addressMain === undefined || stateFixed.addressMain === null || stateFixed.addressMain === '') {
      stateFixed.addressMain = addressMainActual;
    }

    message = `I want to use monacotto. My main address is ${stateFixed.addressMain}. My name is ${stateFixed.userName}. I will send cards from ${stateFixed.addressCardFromDefault} and I want to receive proceeds in ${stateFixed.addressPayProceedsToDefault} as default. I will pay from ${stateFixed.addressPayFromDefault} and I want to receive cards in ${stateFixed.addressSendCardToDefault} as default. I accept the terms and conditions version ${stateFixed.acceptedVersionOfTheTermsAndConditions} and privacy policy version ${stateFixed.acceptedVersionOfPrivacyPolicy}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
    devLog('message', message);

    try {
      signature = signWithKeyNW({ dispatch, keyPair, message, network, language });
    }
    catch (error) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[language] });
      return 'rejected';
    }
  }
  else if (stateFixed.walletType === 'mpurse') {
    // Mpurseのアドレスが合ってるかチェック
    result = await window.mpurse.getAddress()
    .then( (result) => {
      addressMainActual = result;
      stateFixed.addressMain = addressMainActual;

      message = `I want to use monacotto. My main address is ${stateFixed.addressMain}. My name is ${stateFixed.userName}. I will send cards from ${stateFixed.addressCardFromDefault} and I want to receive proceeds in ${stateFixed.addressPayProceedsToDefault} as default. I will pay from ${stateFixed.addressPayFromDefault} and I want to receive cards in ${stateFixed.addressSendCardToDefault} as default. I accept the terms and conditions version ${stateFixed.acceptedVersionOfTheTermsAndConditions} and privacy policy version ${stateFixed.acceptedVersionOfPrivacyPolicy}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
      devLog('message', message);
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // 署名
    result = await window.mpurse.signMessage(message)
    .then( result => {
      signature = result;
      return 'fulfilled';
    })
    .catch( err => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[language] });
      return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }
  }
  else {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'keybox') {
      }
      else if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    return { status: 'rejected' };
  }

  const formData = new FormData();

  const requestJson = JSON.stringify({
    "body": {
      "method": 'upsert',
      "addressMain": stateFixed.addressMain,
      "addressMainActual": addressMainActual,
      "addressCardFromDefault": stateFixed.addressCardFromDefault,
      "addressPayProceedsToDefault": stateFixed.addressPayProceedsToDefault,
      "addressPayFromDefault": stateFixed.addressPayFromDefault,
      "addressSendCardToDefault": stateFixed.addressSendCardToDefault,
      "userName": stateFixed.userName,
      "homed": stateFixed.homed,
      "profileText": stateFixed.profileText,
      "acceptedVersionOfTheTermsAndConditions": stateFixed.acceptedVersionOfTheTermsAndConditions,
      "acceptedVersionOfPrivacyPolicy": stateFixed.acceptedVersionOfPrivacyPolicy,
      "clientTime" : clientTime,
      "signature" : signature,
      "signatureVersion" : stateFixed.signatureVersion,
    }
  });

  formData.append('json', requestJson);

  if (stateFixed.imageMain !== undefined && stateFixed.imageMain !== null) {
    formData.append('imageMain', stateFixed.imageMain, stateFixed.imageMain.name);
  }

  request.body = formData;
  request.headers = {};
  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/configure';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[language],
    "internal server error": words.internalServerError[language],
    "bad signature": words.badSignature[language],
    "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[language],
    "unknown signatureVersion": words.unknownSignatureVersion[language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[language],
    "this address is forbidden.": words.thisAddressIsForbidden[language],
    "out of service": words.outOfService[language],
    "you are not delegated.": words.norIsTheSignatureDelegatedFromMainAddress[language],
    "addressMainActual must be filled.": words.clearYourBrowserOrAppCache[language],
    "success": words.success[language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    // session情報更新
    dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressMain],
      value: {'sessionId': response.body.sessionId[stateFixed.addressMain], 'expirationOfSession': response.body.expirationOfSession[stateFixed.addressMain]} });

    if (addressMainActual !== stateFixed.addressMain) {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', addressMainActual],
      value: {'sessionId': response.body.sessionId[addressMainActual], 'expirationOfSession': response.body.expirationOfSession[addressMainActual]} });
    }

    /*
    // 基本情報をconfigureにセット
    dispatch({ type: 'setState', key: 'configure', value: response.body[stateFixed.addressMain].basicInformation });
    */

    // 各種stateにメインアドレスをセット
    for (const keys of stateKeysToSetAddress) {
      dispatch({ type: 'setStateMultiLayers', keys: keys, value: stateFixed.addressMain });
    }

    // -- ユーザ情報取得
    const usersGeneral = await getUser({ dispatch, getType: 'all' }); // all じゃなくていいような気がする。
    devLog('usersGeneral', JSON.stringify(usersGeneral));

    let usersGeneralIndex = {};

    for (const user of usersGeneral.body) {
      usersGeneralIndex[user.addressMain] = user;
    }

    dispatch({ type: 'setState', key: 'usersGeneralIndex', value: usersGeneralIndex });

    // cookie情報更新(アドレス情報)
    const userName = usersGeneralIndex[stateFixed.addressMain] !== undefined ? usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
    const cookiesNew = [
          {
            action: 'setUp',
            addressType: 'addressMain',
            description: `${userName}`,
            time: clientTime,
            address: stateFixed.addressMain
          },
    ];

    setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters });

    // 保有アセット取得
    getBalancesMonaparty({ dispatch, address: stateFixed.addressMain, clientParameters })
    .then( (result) => {
      let assets;

      if (result.status === 'fulfilled') {
        const balance = result.body;
        assets = Object.keys(balance);
      }
      else {
        throw new Error(result.error);
      }

      // もしかしたら、アセット情報取得は不要かもしれない。
      // アセット情報取得
      return getAssetInfo({ dispatch, assets, assetInfos, clientParameters });
    })
    .then( (result) => {
      let assetInfo;

      if (result.status === 'fulfilled') {
        // eslint-disable-next-line no-unused-vars
        assetInfo = result.body;
      }
      else {
        throw new Error(result.error);
      }

      // // モナカード情報取得
      // const assetCommons = Object.keys(assetInfo)
      // .filter( asset => {
      //   try {
      //     return JSON.parse(assetInfo[asset]?.description).monacard === undefined;
      //   }
      //   catch (error) {
      //     return true;
      //   }
      // })
      // .map( asset => assetInfo[asset].asset_longname === null ? asset : assetInfo[asset].asset_longname );

      // getMonacard({ dispatch, assets: assetCommons, monacards });
    })
    .catch( (error) => {
      // エラー＆再ログインしてください通知。
    })

    // // MONA残高取得

    // getAddressInfo({ clientParameters, address: stateFixed.addressMain })
    // .then( (result) => {
    //   if (result.status === 'fulfilled') {
    //     const balance = result.body.balance;
    //     dispatch({ type: 'setStateMultiLayers', keys: ['balance', 'mona', stateFixed.addressMain], value: balance });
    //   }
    //   else {
    //     devLog('failed to get address info.');
    //     // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[language] + '3.5' });
    //   }
    // });

    // // オウンドアセット情報取得
    // getOwnedAssets({ dispatch, address: stateFixed.addressMain, clientParameters })
    // .then( (result) => {
    //   if (result.status === 'fulfilled') {
    //   }
    //   else {
    //     devLog('failed to get owned asset.');
    //     // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[language] + '3.5' });
    //   }
    // });

    // // デッキ取得
    // loadDeck({
    //   session,
    //   dispatch,
    //   certificationAdditional: { addressMain: stateFixed.addressMain, sessionId: response.body.sessionId.addressMain },
    //   marginOfSessionTime,
    // });
  }
  else {
  }

  return response;
}

export {
  checkRequiredItemsForSetup,
  handleClickSetup,
};
